// silent console.* operations depends on GATSBY_LOG_LEVEL_SILENT env var
// use comma separated keys of consoleLevels array as value to env var to silent specified outputs
// example for production error only: GATSBY_LOG_LEVEL_SILENT=warn,log,info,debug
// example GATSBY_LOG_LEVEL_SILENT=ALL will block all mentioned levels of console
const consoleLevels = {
  error: ['error'],
  warn: ['warn'],
  log: ['log', 'table'],
  info: ['info'],
  debug: ['debug', 'trace', 'profile', 'profileEnd', 'timeStamp', 'time', 'timeEnd', 'timeLog'],
};
let logLevelToSilent = process.env.GATSBY_LOG_LEVEL_SILENT;
if (logLevelToSilent) {
  if (logLevelToSilent === 'ALL') {
    logLevelToSilent = 'error,warn,log,info,debug';
  }
  const silentLevel = logLevelToSilent.split(',');
  const noop = () => { /* NOOP */ };
  silentLevel.forEach((level) => {
    if (consoleLevels[level]) {
      consoleLevels[level].forEach((consoleFunction) => {
        console[consoleFunction] = noop;
      });
    } else {
      console.error(`Invalid level "${level}" specified in GATSBY_LOG_LEVEL_SILENT environment variable`);
    }
  });
} else if (process.env.GATSBY_LOG_LEVEL_SILENT === undefined) {
  console.log('No logs filtered out, set GATSBY_LOG_LEVEL_SILENT if needed');
}
